export default __webpack_public_path__ + "static/media/horn.a3c4f12c.wav";